import CounterCard from "./CounterCard";
import LatestEdits from "./LatestEdits";
import LatestList from "./LatestList";
import OverTimeChart from "./OverTimeChart";
import PercentageChart from "./PercentageChart";
import { PercentageList } from "./PercentageList/PercentageList";

export const chartMapper = {
    CounterCard,
    OverTimeChart,
    LatestList,
    PercentageChart,
    PercentageList,
    LatestEdits,
};

export { CounterCard, LatestEdits, LatestList, OverTimeChart, PercentageChart, PercentageList };
